import { Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";

/**
 * Centralised "this feature is temporarily disabled" empty state used by:
 * - /credit-report (when credit_report_upload OFF)
 * - /dispute-letters and /dispute-letters/new (when dispute_letter_generator OFF)
 * - /readiness (when funding_readiness_assessment OFF)
 * - /partners (when both startup + business modules OFF)
 *
 * Reads from FeatureFlagsContext via the calling page; this component is
 * purely presentational. V2 light-first tokens (Batch C4 migration).
 */
export default function FeatureDisabled({
  title = "This feature is temporarily disabled",
  message = "An administrator has paused this part of the app. Please check back later.",
  testId = "feature-disabled",
  backTo = "/dashboard",
  backLabel = "Back to dashboard",
}) {
  return (
    <section
      data-testid={testId}
      data-page-outer="cluster-c4"
      className="min-h-[60vh] flex items-center justify-center px-6 bg-v2-background text-v2-text"
    >
      <div
        className="max-w-md w-full text-center rounded-2xl p-7 border bg-v2-surface border-v2-border shadow-v2-card"
      >
        <div
          className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4 border"
          style={{
            background: "var(--v2-accent-soft)",
            borderColor: "var(--v2-accent)",
          }}
        >
          <Lock className="w-5 h-5" style={{ color: "var(--v2-accent)" }} />
        </div>
        <h2
          className="text-xl text-v2-text mb-2"
          style={{ fontFamily: "'Space Grotesk', 'Inter', sans-serif" }}
        >
          {title}
        </h2>
        <p className="text-sm text-v2-textMuted">{message}</p>
        <Link
          to={backTo}
          data-testid={`${testId}-back`}
          className="mt-5 inline-flex items-center gap-1.5 rounded-md border border-v2-border px-4 py-2 text-sm text-v2-text hover:bg-v2-surfaceSubtle transition-colors"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> {backLabel}
        </Link>
      </div>
    </section>
  );
}
